import {
    assignModelOptions,
    ClientManagerInstanceToken,
    CompositeModel,
    ConfigConstants,
    ConfigService,
    CustomInjector,
    EquipmentModel,
    ModelOptionsLoaderService,
    TextModel,
} from '@evorait/pace-core';

export class EquipmentConfigurationServiceKeyModel extends CompositeModel {
    public materialNo: TextModel;
    public serialNo: TextModel;
    public hwid: TextModel;
    public frontId: TextModel;
    public qmNum: TextModel;
    public equipmentNo: TextModel;
    public equipment: EquipmentModel;
    public constructor(
        equipmentModel: EquipmentModel,
        notificationNo: string,
        process: ConfigConstants.PROCESS_INDICATOR,
    ) {
        super('EquipmentConfigurationServiceKeyModel');

        const injector = CustomInjector.getInjector();
        const configService = injector.get(ConfigService);
        const modelOptionsLoader = injector.get(ModelOptionsLoaderService);
        const clientManager = injector.get(ClientManagerInstanceToken);

        this.frontId = <TextModel>this.set(new TextModel('FrontId', configService.getUserFrontId()));
        if (clientManager.isPaceUS()) {
            this.equipmentNo = <TextModel>this.set(new TextModel('EquipmentNo', equipmentModel.equnr.value));
            modelOptionsLoader.load(this.equipmentNo, 'GetServiceKey', 'EquipmentNumber');
            this.equipment = equipmentModel;
        } else {
            this.materialNo = <TextModel>this.set(new TextModel('Material', equipmentModel.matnr.value));
            modelOptionsLoader.load(this.materialNo, 'GetServiceKey', 'MaterialNumber', process);
            this.materialNo = assignModelOptions(
                this.materialNo,
                {
                    ...this.materialNo.options,
                    applicationIdentifier: ConfigConstants.ApplicationIdentifier.ProductIdentifier,
                },
                this,
            );
            this.serialNo = <TextModel>this.set(new TextModel('SerialNum', equipmentModel.sernr.value));
            modelOptionsLoader.load(this.serialNo, 'GetServiceKey', 'SerialNumber');
            this.serialNo = assignModelOptions(
                this.serialNo,
                {
                    ...this.serialNo.options,
                    applicationIdentifier: ConfigConstants.ApplicationIdentifier.SerialNumber,
                },
                this,
            );
            this.hwid = <TextModel>this.set(new TextModel('HardwareId'));
            modelOptionsLoader.load(this.hwid, 'GetServiceKey', 'HWID');
            this.qmNum = <TextModel>this.set(new TextModel('NotificationNo', notificationNo));
            this.resetRequiredOption();
        }
    }

    /**
     * Called from markup to reset 'required' property of input fields based on logic
     * (Material Number AND Serial Number) OR HardwareId ID is the required input
     */
    public resetRequiredOption(): void {
        this.materialNo = assignModelOptions(
            this.materialNo,
            {
                ...this.materialNo.options,
                required: !this.hwid.value,
            },
            this,
        );
        this.serialNo = assignModelOptions(
            this.serialNo,
            {
                ...this.serialNo.options,
                required: !this.hwid.value,
            },
            this,
        );
        this.hwid = assignModelOptions(
            this.hwid,
            {
                ...this.hwid.options,
                required: !this.materialNo.value && !this.serialNo.value,
            },
            this,
        );
        this.materialNo = assignModelOptions(
            this.materialNo,
            {
                ...this.materialNo.options,
                readonly: !this.materialNo.options.required,
            },
            this,
        );
        this.serialNo = assignModelOptions(
            this.serialNo,
            {
                ...this.serialNo.options,
                readonly: !this.serialNo.options.required,
            },
            this,
        );
        this.hwid = assignModelOptions(
            this.hwid,
            {
                ...this.hwid.options,
                readonly: !this.hwid.options.required,
            },
            this,
        );
    }
}
